import { withTranslation } from 'react-i18next';
import { t } from "../../hooks/useAppTranslation";
import React from "react";
import './LoginInfo.scss';
import {Link} from 'react-router-dom';
import SessionTimer from '../SessionTimer/SessionTimer';
import {getAndSaveRefreshToken, handleLogOut} from "../../Helpers/SessionTimer";
import {SessionTimeoutWarning} from "../SessionTimeoutWarning/SessionTimeoutWarning";
import PopUp from "../PopUp/PopUp";
import {getRemainingTokenTime} from "../../Helpers/utils";
import SelectCustom from '../SelectCustom/SelectCustom';
import {store} from '../../Redux/Store/Store';
import * as actions from '../../Redux/Actions/Programs';
import {connect} from 'react-redux';
import jwt from "jwt-decode";
import moment from "moment";
import LanguageSelector from '../LanguageSelector/LanguageSelector'

export class LoginInfo extends React.Component {
	programsToShowInOptions = [];

    constructor(props) {
        super(props);

        this.state = {
            userDataShow: false,
            userLanguageShow: false,
            overlayShow: false,
			userTime: "",
			date: null
        }
    }

	componentDidMount() {

		if(this.tokenExpired()) {
			handleLogOut();
		} else {
			const userTime = localStorage.getItem("userTime");
			if (userTime) {
				this.setState({userTime});
				this.timerID = setInterval(
					() =>
						this.setState({
							date: getRemainingTokenTime(this.state.userTime),
						}),
					1000
				);
			}
		}

		const callback = () => {
			const allPrograms = store.getState().programs.programs;
			const selectedProgram = store.getState().programs.selected;
			store.getState().userData.user.roleDetails.programDescriptors.forEach(element => {
				const program = allPrograms.find(x => x.code === element.program);
				if (program && !this.programsToShowInOptions.find(x => x?.code === program?.code)) {
					this.programsToShowInOptions.push(program);
				} else if (!this.programsToShowInOptions.find(x => x?.code === program?.code)) {
					this.programsToShowInOptions.push({ ...element, code: element.program });
				}
			});
			const isSelectedProgramInPrograms = Boolean(this.programsToShowInOptions?.some(p => p.code === selectedProgram?.code));
			if (this.programsToShowInOptions.length && (selectedProgram === null || !isSelectedProgramInPrograms)) {
				this.props.setSelectedPrograms(this.programsToShowInOptions[0]);
			}
		}

		this.props.fetchProgramsData(callback);
		this.handleRefreshSessionTime(false)
	}

	componentWillUnmount() {
		clearInterval(this.timerID);
	}

	tokenExpired = () => {
		const token = localStorage.getItem("token");

		if(token) {
			const tokenExpire = jwt(token).exp;

			const expireTime = moment.unix(tokenExpire);
			
			const alreadyExpired = moment().isAfter(expireTime);

			return alreadyExpired;
		}
	}

    showUserData = () => {
        this.setState({
            userDataShow: !this.state.userDataShow,
            overlayShow: !this.state.overlayShow,
			userLanguageShow: false
        })

    };

	handleCloseUserMenu() {
		if(this.state.userDataShow) {
			this.setState({
				userDataShow: false,
				overlayShow: false
			})
		}
	}

	onMenuClick(e) {
		e.preventDefault()
		e.stopPropagation()
	}

	setValues = (values) => {
		if (values.length) {
			this.props.setSelectedPrograms(values[0]);
		}
	};

    printUserInfo = () => {
        let user = localStorage.getItem("user");
        let userRole = localStorage.getItem("userRole");
        let programDescriptors = localStorage.getItem("programDescriptors");
        let org = localStorage.getItem("userOrg");
		const selectedProgram = store.getState().programs.selected;

        return (<div id="user_info" className="user-info" onClick={this.onMenuClick}>
            <p>{t("g-logged-in", { force: true })}: {user} ({userRole})</p>
            {(org || '').length > 0 ? <p>{org}:</p> : ''}
            <div style={{padding: '10px 10px 0 10px', maxHeight: '200px', overflow: 'auto'}}>
                {(programDescriptors || '').split(",").map(el => <div key={el}>{el}</div>)}
            </div>

			{userRole !== 'SA' && 
				<div className='mb-4 program-select'>
					<SelectCustom
						labelField='code'
						placeholder={t("g-programme", { force: true })}
						valueField='code'
						options={this.programsToShowInOptions}
						onChange={(values) => this.setValues(values)}
						multi={false}
						isMulti={false}
						id='programsLoginInfoSelectId'
						dropdownId='programsLoginInfoDropdownId'
						label={t("g-programme", { force: true })}
						parentRef={this.programmsMyControlActiveSelectRef}
						clearable={false}
						values={selectedProgram ? [selectedProgram] : undefined}
					/>
				</div>
			}

			<Link to="/" onClick={handleLogOut}><i data-v-3cb61726="" aria-hidden="true"
															className="v-icon material-icons">logout</i><span>{t("g-log-out", { force: true })}</span></Link>
        </div>)
    };

    printLogin = () => {

        return (
            <div id="user_info" className="user-info">
                <Link to="/login"><i data-v-3cb61726="" aria-hidden="true"
                                     className="v-icon material-icons">exit_to_app</i><span>{t("g-log-in", { force: true })}</span></Link>
            </div>)
    };

	handleRefreshSessionTime = async (showPopUp = true) => {
		this.setState({showPopUp});
		await getAndSaveRefreshToken().then(
			() => {
				const userTime = localStorage.getItem("userTime");
				if (userTime) {
					this.setState({userTime, sessionRefreshed: true});
				}
			},
			(reason) => console.log("Błąd odświeżania tokenu:" + reason)
		);
	};


    render() {
        const user = localStorage.getItem("user");
        let info;
        if (user && user !== "") {
            info = this.printUserInfo()
        } else {
            info = this.printLogin()
        }
		//czasami nie pojawia sie menu z czasem i menu uzytkownika
        if (true) {
            return (
				<>
					<div id="login_info" className="login-info">
						{user && user !== "" && <SessionTimer key={this.state.date} date={this.state.date} handleRefreshSessionTime={this.handleRefreshSessionTime}/>}
						<button
							aria-expanded={this.state.overlayShow}
							type="button"
							className="v-btn v-btn--icon theme--dark white--text"
							onClick={() => this.setState({
								userLanguageShow: !this.state.userLanguageShow,
								userDataShow: false,
            					overlayShow: false,
							})}
						>
							<span className="sr-only">
								{t("g-language-selection", { force: true })}
							</span>
							<div className="v-btn__content">
								<i aria-hidden="true" className="v-icon material-icons white">language</i>
							</div>
						</button>
						<button
							aria-expanded={this.state.overlayShow}
							data-v-1c3d4cc0=""
							type="button"
							className="v-btn v-btn--icon theme--dark white--text"
							onClick={this.showUserData}
						>
                                <span className="sr-only">
                                    {t("g-logged-in-as", { force: true })}: {user}.
									{!this.state.overlayShow && t("g-expand-log-out", { force: true })}
                                </span>
							<div className="v-btn__content">
								<i data-v-6e43d666="" aria-hidden="true"
								   className="v-icon material-icons white">account_circle</i>
							</div>
						</button>
						{this.state.userDataShow ? info : ''}
						{this.state.userLanguageShow && <LanguageSelector onClose={() => this.setState({ userLanguageShow: false, overlayShow: false })} />}
					</div>

					<SessionTimeoutWarning
						refreshSession={this.handleRefreshSessionTime}
						userTime={this.state.userTime}
					/>
					{this.state.showPopUp && this.state.sessionRefreshed && (
						<>
							<PopUp
								title={t("g-notification", { force: true })}
								notification={`${t("g-session-time-prolonged", { force: true })} ${this.state.date}.`}
								onClickEvent={() => {
									this.setState({ sessionRefreshed: false });
								}}
								closePopUp={() => {
									this.setState({ sessionRefreshed: false });
								}}
								className='popUp-session-timer'
								priority='high'
								refreshTokenPopup
							/>
							<span role='alert' className='sr-only'>
							  {t("g-session-time-prolonged", { force: true })} {this.state.date}
							  .
							</span>
						</>
					)}
				</>
            )
        } else return ''

    }
}

const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchProgramsData: (successCallback) => dispatch(actions.getProgramsData(successCallback)),
		setSelectedPrograms: (programs) => dispatch(actions.setSelectedProgsData(programs)),
	}
};

export const LoginInfoProvider = connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(withTranslation()(LoginInfo));